import { useAtomValue } from "jotai";
import { TriangleAlertIcon } from "lucide-react";

import { shouldShowValidationVar } from "./lib";

export interface FieldValidationMessagesProps {
  messages: Array<string>;
}

export function FieldValidationMessages({
  messages,
}: FieldValidationMessagesProps) {
  const shouldShowValidation = useAtomValue(shouldShowValidationVar);

  if (!shouldShowValidation || messages.length === 0) return;

  return (
    <div className="text-redText text-bodymd flex items-center gap-1">
      <TriangleAlertIcon className="size-4" />
      <ul>
        {messages.map((message, index) => {
          return <li key={index}>{message}</li>;
        })}
      </ul>
    </div>
  );
}
